import React from "react";
import { useNavigate } from "react-router-dom";
import "./AlertCTA.css";

const AlertCTA = () => {
  const navigate = useNavigate();
  const [showAlertCard, setShowAlertCard] = React.useState(false);
  // Desktop starts expanded, mobile will show FAB because card is CSS-hidden
  const [alertCollapsed, setAlertCollapsed] = React.useState(false);

  const handleRegister = () => {
    setShowAlertCard(false);
    navigate("/register", { state: { openSignUp: true } });
  };

  const isMobile = () => window.innerWidth < 768;

  const handleFabClick = () => {
    if (isMobile()) {
      setShowAlertCard(true);
    } else {
      setAlertCollapsed(false);
    }
  };

  return (
    <>
      {/* ── Desktop card (visible on desktop, hidden on mobile via CSS) ── */}
      {!alertCollapsed && (
        <div className="alert-cta-desktop">
          <div className="alert-cta-card">
            <div className="alert-cta-header">
              <span className="alert-cta-icon">🔔</span>
              <span className="alert-cta-title">Notifications</span>
              <button
                className="alert-cta-close"
                onClick={() => setAlertCollapsed(true)}
                aria-label="Fermer"
              >
                ✕
              </button>
            </div>
            <p className="alert-cta-message">
              Recevez des notifications par e-mail de la situation prévisionnelle « Risques feux de forêt » dans votre département.
            </p>
            <div className="alert-cta-divider" />
            <button className="signup-submit-btn" onClick={handleRegister}>
              S'INSCRIRE
            </button>
          </div>
        </div>
      )}

      {/* ── FAB: always render when collapsed, OR when on mobile (since desktop card is hidden) ── */}
      {(alertCollapsed || isMobile()) && !showAlertCard && (
        <button
          className="alert-fab"
          onClick={handleFabClick}
          aria-label="Notifications"
        >
          🔔
        </button>
      )}

      {/* ── Mobile modal ── */}
      {showAlertCard && (
        <>
          <div
            className="alert-modal-overlay"
            onClick={() => setShowAlertCard(false)}
          />
          <div className="alert-modal">
            <button
              className="alert-modal-close"
              onClick={() => setShowAlertCard(false)}
              aria-label="Fermer"
            >
              ✕
            </button>
            <div className="alert-cta-header">
              <span className="alert-cta-icon">🔔</span>
              <span className="alert-cta-title">Notifications</span>
            </div>
            <p className="alert-cta-message">
              Recevez des notifications par e-mail de la situation prévisionnelle « Risques feux de forêt » dans votre département 
            </p>
            <div className="alert-cta-divider" />
            <button className="signup-submit-btn" onClick={handleRegister}>
              S'INSCRIRE
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default AlertCTA;